import VueTypes from 'vue-types';
import { SEAT_TYPE } from '@/mikan/_shared/constants/spot';

export const VTSpotId = VueTypes.string;
export const SpotProps = {
  id: VTSpotId.isRequired,
  publicName: VueTypes.string.isRequired,
  privateName: VueTypes.oneOfType([VueTypes.string, null]).isRequired, // なぜかnullなやつが本番に居たので
  seatType: VueTypes.oneOf([null, ...Object.values(SEAT_TYPE).map(({ value }) => value)]), // 一括コピーの不具合でnullなやつがいる
  min: VueTypes.number.isRequired,
  max: VueTypes.number.isRequired,
  canSmoke: VueTypes.bool.isRequired,
  canConnect: VueTypes.bool.isRequired,
  imageId: VueTypes.oneOfType([VueTypes.number, null]).isRequired,
  imageUrl: VueTypes.oneOfType([VueTypes.string, null]).isRequired,
  coverCharge: VueTypes.oneOfType([VueTypes.string, null]).isRequired,
  coverChargeFee: VueTypes.oneOfType([VueTypes.number, null]).isRequired,
  rateOfCoverCharge: VueTypes.oneOfType([VueTypes.number, null]).isRequired,
  hasCoverCharge: VueTypes.bool.isRequired,
  hasCoverChargeFee: VueTypes.bool.isRequired,
  hasRateOfCoverCharge: VueTypes.bool.isRequired,
};
export const VTSpot = VueTypes.shape(SpotProps);
